import React from "react";
import { IconType } from "react-icons";
import { Card, CardContent, Box, Typography } from "@mui/material";

type Props = {
  title: string;
  value: number | string;
  Icon: IconType;
  // Theme palette path (e.g. "warning.main"), resolved via sx — not a raw
  // hex value. Defaults to the brand color when the stat has no particular
  // semantic (warning/success/etc.) meaning.
  color?: string;
};

const StatisticsCard = ({ title, value, Icon, color = "primary.main" }: Props) => {
  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          "&:last-child": { pb: 2 },
        }}
      >
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            {title}
          </Typography>
          <Typography variant="h6" fontWeight="bold" sx={{ color }}>
            {typeof value === "number" ? value.toLocaleString() : value}
          </Typography>
        </Box>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "action.hover",
            color,
            flexShrink: 0,
          }}
        >
          <Icon size={22} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatisticsCard;
